const KeyboardArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.5001 13.2292L10.7334 9.99583L7.5001 6.7625C7.1751 6.4375 7.1751 5.9125 7.5001 5.5875C7.8251 5.2625 8.3501 5.2625 8.6751 5.5875L12.5001 9.4125C12.8251 9.7375 12.8251 10.2625 12.5001 10.5875L8.6751 14.4125C8.3501 14.7375 7.8251 14.7375 7.5001 14.4125C7.18343 14.0875 7.1751 13.5542 7.5001 13.2292Z"
        fill="#DFE1E2"
      />
    </svg>
  );
};

export default KeyboardArrowRight;
